"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BnsGetNameInfoResponseToJSON = exports.BnsGetNameInfoResponseFromJSONTyped = exports.BnsGetNameInfoResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function BnsGetNameInfoResponseFromJSON(json) {
    return BnsGetNameInfoResponseFromJSONTyped(json, false);
}
exports.BnsGetNameInfoResponseFromJSON = BnsGetNameInfoResponseFromJSON;
function BnsGetNameInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'blockchain': json['blockchain'],
        'expire_block': !runtime_1.exists(json, 'expire_block') ? undefined : json['expire_block'],
        'grace_period': !runtime_1.exists(json, 'grace_period') ? undefined : json['grace_period'],
        'last_txid': json['last_txid'],
        'resolver': !runtime_1.exists(json, 'resolver') ? undefined : json['resolver'],
        'status': json['status'],
        'zonefile': json['zonefile'],
        'zonefile_hash': json['zonefile_hash'],
    };
}
exports.BnsGetNameInfoResponseFromJSONTyped = BnsGetNameInfoResponseFromJSONTyped;
function BnsGetNameInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'blockchain': value.blockchain,
        'expire_block': value.expire_block,
        'grace_period': value.grace_period,
        'last_txid': value.last_txid,
        'resolver': value.resolver,
        'status': value.status,
        'zonefile': value.zonefile,
        'zonefile_hash': value.zonefile_hash,
    };
}
exports.BnsGetNameInfoResponseToJSON = BnsGetNameInfoResponseToJSON;
//# sourceMappingURL=BnsGetNameInfoResponse.js.map